"use strict";
/**
 * DataEditView ist die editierbare Ansicht
 *
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var loadSingleEntityData_1 = __importDefault(require("../../fetch/loadSingleEntityData"));
var react_redux_1 = require("react-redux");
var crude_selector_1 = require("../../store/crude/crude.selector");
var getFetchHeaders_1 = __importDefault(require("../../shared/util/getFetchHeaders"));
var material_1 = require("@mui/material");
var react_i18next_1 = require("react-i18next");
var DataEditTabs_1 = __importDefault(require("../../screens/DataEditView/DataEditTabs"));
var DataTableView_1 = __importDefault(require("../../screens/DataTableView/DataTableView"));
var getDefaultTableFilterSettings_1 = __importDefault(require("../../defaults/getDefaultTableFilterSettings"));
var schemaTypes_1 = require("../../shared/types/schemaTypes");
var commonTypes_1 = require("../../shared/types/commonTypes");
var DataEditLayoutForm_1 = __importDefault(require("../../screens/DataEditView/DataEditLayoutForm"));
var DataEditForm_1 = __importDefault(require("../../screens/DataEditView/DataEditForm"));
var DataEditButtons_1 = __importStar(require("./DataEditButtons"));
var createEntityData_1 = __importDefault(require("../../fetch/createEntityData"));
var editEntityData_1 = __importDefault(require("../../fetch/editEntityData"));
var translateMessage_1 = __importDefault(require("../../shared/util/translateMessage"));
var messageTypes_1 = require("../../shared/types/messageTypes");
var crudeActions = __importStar(require("../../store/crude/crude.actions"));
var crude_actions_1 = require("../../store/crude/crude.actions");
var deleteEntityData_1 = __importDefault(require("../../fetch/deleteEntityData"));
var react_router_1 = require("react-router");
var styles_1 = require("@mui/styles");
var validateEnityData_1 = __importDefault(require("./util/validateEnityData"));
var DialogComponent_1 = __importDefault(require("../../shared/components/MessageComponents/DialogComponent"));
var useStyles = styles_1.makeStyles(function (theme) { return ({
    paper: {
        padding: theme.spacing(3),
    },
}); });
var DataEditView = function (props) {
    var _a, _b;
    var t = react_i18next_1.useTranslation().t;
    var dispatch = react_redux_1.useDispatch();
    var history = react_router_1.useHistory();
    var classes = useStyles();
    var entity = props.entity;
    var id = props.id || 'new';
    var showInPopup = props.showInPopup || false;
    var hideBackButton = props.hideBackButton || false;
    var dataViewType = props.dataViewType || commonTypes_1.DataViewType.fullView;
    var temporaryJoinData = react_redux_1.useSelector(crude_selector_1.getTemporaryJoinData);
    var appLayout = react_redux_1.useSelector(crude_selector_1.getAppLayout);
    var crudeLanguage = react_redux_1.useSelector(crude_selector_1.getLanguage);
    var crudeLabels = react_redux_1.useSelector(crude_selector_1.getCrudeLabels)[crudeLanguage];
    var crudeConfig = react_redux_1.useSelector(crude_selector_1.getCrudeConfiguration);
    var crudeSchema = react_redux_1.useSelector(crude_selector_1.getCrudeSchema);
    var editLayout = react_redux_1.useSelector(crude_selector_1.getEditLayout);
    var lastEntity = react_redux_1.useSelector(crude_selector_1.getLastActiveEntity);
    var crudeTabs = react_redux_1.useSelector(crude_selector_1.getCrudeTabs);
    var storedTableFilterSettings = react_redux_1.useSelector(crude_selector_1.getTableFilterSettings);
    var entityEditLayout = editLayout && editLayout.entities.find(function (entityLayout) { return entityLayout.entity === entity; });
    var entitySchema = crudeSchema && crudeSchema.find(function (entitySchema) { return entitySchema.name === entity; });
    var fetchHeaders = crudeConfig.api.headers ? getFetchHeaders_1.default(crudeConfig.api.headers) : {};
    var _c = react_1.useState(false), openDeleteDialog = _c[0], setOpenDeleteDialog = _c[1];
    var _d = react_1.useState(), fetchResponse = _d[0], setFetchResponse = _d[1];
    var _e = react_1.useState(), data = _e[0], setData = _e[1];
    var _f = react_1.useState(), message = _f[0], setMessage = _f[1];
    var _g = react_1.useState(), editTabs = _g[0], setEditTabs = _g[1];
    var _h = react_1.useState(false), dataValidation = _h[0], setDataValidation = _h[1];
    var _j = react_1.useState(0), editTab = _j[0], setEditTab = _j[1];
    var _k = react_1.useState(''), embeddingEntity = _k[0], setEmbeddingEntity = _k[1];
    var _l = react_1.useState(), embeddingEntityFilter = _l[0], setEmbeddingEntityFilter = _l[1];
    var _m = react_1.useState({
        delete: true,
        edit: true,
        create: true,
    }), buttonActivation = _m[0], setButtonActivation = _m[1];
    var _o = react_1.useState(), disableJoinColumns = _o[0], setDisableJoinColumns = _o[1];
    react_1.useEffect(function () {
        props.disableJoinColumns && setDisableJoinColumns(props.disableJoinColumns);
    }, [props.disableJoinColumns]);
    react_1.useEffect(function () {
        setEditTab(0);
    }, [props.id]);
    react_1.useEffect(function () {
        data && entitySchema && setDataValidation(validateEnityData_1.default(data, entitySchema, id));
    }, [data]);
    react_1.useEffect(function () {
        if (message && crudeLabels) {
            var text = translateMessage_1.default(message.message, crudeLabels, props.entity);
            var newMessage = {
                eventType: message.eventType,
                severity: message.status && message.status >= 400 ? messageTypes_1.Severity.error : messageTypes_1.Severity.success,
                message: text,
            };
            message && dispatch(crudeActions.addMessage(newMessage));
        }
    }, [message]);
    react_1.useEffect(function () {
        setButtonActivation(__assign(__assign({}, buttonActivation), { create: dataValidation, edit: dataValidation }));
    }, [dataValidation]);
    var getBackToTableView = function () {
        var tab = crudeTabs && crudeTabs.findIndex(function (tab) { return tab.entity === lastEntity; });
        tab && dispatch(crudeActions.setActiveTab(tab));
        lastEntity && dispatch(crude_actions_1.setActiveEntity(lastEntity));
        history.goBack();
    };
    react_1.useEffect(function () {
        var _a;
        if (fetchResponse) {
            props.onChangeCrudeSingleEntityData && fetchResponse.data && props.onChangeCrudeSingleEntityData(fetchResponse.data);
            if (fetchResponse.status && fetchResponse.status < 400) {
                if (fetchResponse.eventType === messageTypes_1.EventType.create) {
                    // JoinEntities noch erstellen, wenn welche restored
                    var newId_1;
                    // TODO id noch in den Datas übergeben > nicht in den parameters nutzen!!!
                    (entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.idColumn) && ((_a = fetchResponse.message.parameters) === null || _a === void 0 ? void 0 : _a.map(function (param) {
                        if (param.key === (entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.idColumn)) {
                            newId_1 = param.value;
                        }
                    }));
                    Object.keys(temporaryJoinData).map(function (elem) {
                        temporaryJoinData[elem].map(function (entityJoin) {
                            var joinEntity = entityJoin.entity;
                            // new durch id ersetzen
                            var newJoin = {};
                            Object.keys(entityJoin.data).map(function (elem) {
                                if (entityJoin.data[elem] === 'new') {
                                    newJoin[elem] = newId_1;
                                }
                                else {
                                    newJoin[elem] = entityJoin.data[elem];
                                }
                            });
                            createEntityData_1.default(crudeConfig.api.restPath, crudeConfig.api.app, joinEntity, newJoin, fetchHeaders, setFetchResponse);
                        });
                    });
                    dispatch(crudeActions.setTemporaryJoinData({}));
                }
                dispatch(crude_actions_1.setReloadListEntity(entity));
                if (dataViewType === commonTypes_1.DataViewType.fullView) {
                    if (appLayout.embeddedEditFormMainLevel && fetchResponse.eventType !== messageTypes_1.EventType.create) {
                        dispatch(crude_actions_1.setShowCollapse(false));
                    }
                    else {
                        getBackToTableView();
                    }
                }
                else {
                    dispatch(crude_actions_1.setShowDialog(false));
                }
            }
            if (fetchResponse.message && crudeLabels) {
                var text = translateMessage_1.default(fetchResponse.message, crudeLabels, props.entity);
                var message_1 = {
                    eventType: fetchResponse.eventType,
                    severity: fetchResponse.status && fetchResponse.status >= 400 ? messageTypes_1.Severity.error : messageTypes_1.Severity.success,
                    message: text,
                };
                fetchResponse && dispatch(crudeActions.addMessage(message_1));
            }
            setButtonActivation(__assign(__assign({}, buttonActivation), { create: dataValidation, edit: dataValidation }));
        }
    }, [fetchResponse]);
    react_1.useEffect(function () {
        id && id !== 'new' && loadSingleEntityData_1.default(crudeConfig.api.restPath, crudeConfig.api.app, entity, fetchHeaders, id, setData, setMessage);
    }, [props.entity, props.id]);
    var changeEditTab = function (tabIndex) {
        var _a, _b;
        dispatch(crudeActions.setReloadListEntity(embeddingEntity));
        setEditTab(tabIndex);
        var nameOfCurrentEntry = entity;
        var incomingReference = editTabs && (entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.incomingReferences.find(function (ref) { return ref.sourceEntity === editTabs[tabIndex].sourceEntity && ref.sourceColumn === editTabs[tabIndex].sourceColumn; }));
        var embeddingEntityFilterInfo = {
            name: nameOfCurrentEntry,
            key: (incomingReference === null || incomingReference === void 0 ? void 0 : incomingReference.sourceColumn) ? incomingReference === null || incomingReference === void 0 ? void 0 : incomingReference.sourceColumn : '',
            value: id,
        };
        var embeddingEntityInfo = (incomingReference === null || incomingReference === void 0 ? void 0 : incomingReference.sourceEntity) || '';
        if (incomingReference === null || incomingReference === void 0 ? void 0 : incomingReference.manyToManyOppositeEntityName) {
            embeddingEntityInfo = incomingReference === null || incomingReference === void 0 ? void 0 : incomingReference.manyToManyOppositeEntityName;
            embeddingEntityFilterInfo.joinEntity = incomingReference === null || incomingReference === void 0 ? void 0 : incomingReference.sourceEntity;
        }
        setEmbeddingEntity(embeddingEntityInfo);
        setEmbeddingEntityFilter(embeddingEntityFilterInfo);
        var newFilterSettings = __assign(__assign({}, storedTableFilterSettings), (_a = {}, _a[embeddingEntityInfo] = __assign(__assign({}, storedTableFilterSettings[embeddingEntityInfo]), (_b = {}, _b[props.treeViewLevel + 1] = __assign(__assign({}, storedTableFilterSettings[embeddingEntityInfo][props.treeViewLevel + 1]), { page: 0, search: '', filter: {} }), _b)), _a));
        dispatch(crudeActions.setTableFilterSettings(newFilterSettings));
    };
    var cleanString = function (value) {
        // let replacedValue: string | null = value ? value.replace(/<p[^>]*>/g, '').replace('<br>', '').replace(/<\/p[^>]*>/g, '</br>') : value
        var replacedValue = value;
        if (value === '<p><br></p>' || value === '<br>') {
            replacedValue = null;
        }
        return replacedValue;
    };
    var dataAction = function (entity, action, id) {
        var selectedEntityData = {};
        data && Object.keys(data.data).map(function (column) {
            var columnSchema = entitySchema && entitySchema.columns.find(function (schema) { return schema.name === column; });
            var readOnly = false;
            // schema prüfen
            if (columnSchema && columnSchema.readOnly) {
                readOnly = true;
            }
            // instancePermissions prüfen
            if (id && data.instancePermissions && data.instancePermissions[id] && data.instancePermissions[id].columns[column] === commonTypes_1.Permission.ReadOnly) {
                readOnly = true;
            }
            if (!readOnly) {
                selectedEntityData[column] = (columnSchema === null || columnSchema === void 0 ? void 0 : columnSchema.columnType) === schemaTypes_1.ColumnType.HtmlRichText ? cleanString(data.data[column]) : data.data[column];
            }
        });
        if (action === DataEditButtons_1.CrudeAction.create) {
            data && createEntityData_1.default(crudeConfig.api.restPath, crudeConfig.api.app, entity, selectedEntityData, fetchHeaders, setFetchResponse);
        }
        if (action === DataEditButtons_1.CrudeAction.edit) {
            data && id && editEntityData_1.default(crudeConfig.api.restPath, crudeConfig.api.app, entity, id, selectedEntityData, fetchHeaders, setFetchResponse);
        }
        if (action === DataEditButtons_1.CrudeAction.delete) {
            setOpenDeleteDialog(true);
        }
        if (action === DataEditButtons_1.CrudeAction.cancel) {
            dispatch(crude_actions_1.setShowDialog(false));
            dispatch(crude_actions_1.setShowCollapse(false));
        }
        if (action === DataEditButtons_1.CrudeAction.back) {
            getBackToTableView();
        }
    };
    var deleteEntity = function () {
        setOpenDeleteDialog(false);
        id && deleteEntityData_1.default(crudeConfig.api.restPath, crudeConfig.api.app, entity, fetchHeaders, id, setFetchResponse);
    };
    var tableFilterSettings = getDefaultTableFilterSettings_1.default();
    if (appLayout.initialPageSize) {
        tableFilterSettings.pageSize = appLayout.initialPageSize;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.Paper, { elevation: 1, className: classes.paper },
            react_1.default.createElement(material_1.Typography, { variant: 'h5', component: 'h3', sx: { mb: 3 } }, (((_b = (_a = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _a === void 0 ? void 0 : _a.entity[props.entity]) === null || _b === void 0 ? void 0 : _b.title) || props.entity) + " -\n          " + (id ? t('crude:edit') : t('crude:create'))),
            !showInPopup &&
                react_1.default.createElement(DataEditTabs_1.default, { setEditTabs: function (tabs) { return setEditTabs(tabs); }, entityEditLayout: entityEditLayout, entity: entity, initialTab: editTab, dataViewType: dataViewType, changeEditTab: changeEditTab }),
            ((editTabs && !editTabs[editTab].sourceEntity) || !editTabs) &&
                react_1.default.createElement(react_1.default.Fragment, null,
                    entityEditLayout
                        ? (react_1.default.createElement(DataEditLayoutForm_1.default, { disableJoinColumns: disableJoinColumns, editTab: editTab, treeViewLevel: props.treeViewLevel, entity: entity, data: data, embeddingEntityFilter: props.embeddingEntityFilter, id: id, showInPopup: showInPopup, entityEditLayout: entityEditLayout, onChangeData: function (data) {
                                setData(data);
                                entitySchema && setDataValidation(validateEnityData_1.default(data, entitySchema, id));
                            } }))
                        : (react_1.default.createElement(DataEditForm_1.default, { disableJoinColumns: disableJoinColumns, entity: entity, data: data, embeddingEntityFilter: props.embeddingEntityFilter, id: id, onChangeData: function (data) {
                                setData(data);
                                entitySchema && setDataValidation(validateEnityData_1.default(data, entitySchema, id));
                            } })),
                    react_1.default.createElement(DataEditButtons_1.default, { entity: entity, data: data, id: id, hideBackButton: hideBackButton, buttonActivation: buttonActivation, onClick: function (entity, action, id) {
                            dataAction(entity, action, id);
                        } })),
            editTabs && editTabs[editTab].sourceEntity && id && embeddingEntity &&
                react_1.default.createElement(DataTableView_1.default, { entity: embeddingEntity, treeViewLevel: props.treeViewLevel + 1, embeddingEntityFilter: embeddingEntityFilter })),
        react_1.default.createElement(DialogComponent_1.default, { message: t('crude:deleteEntityQuestion'), title: t('crude:deleteEntityQuestionTitle'), open: openDeleteDialog, request: true, severity: messageTypes_1.Severity.warning, onClose: function () { return setOpenDeleteDialog(false); }, confirmLabel: t('crude:delete'), autoClose: false, onConfirm: deleteEntity, onCancel: function () { return setOpenDeleteDialog(false); } })));
};
exports.default = DataEditView;
